import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import BonsCoupsContext from "../../../application/Context/BonsCoupsContext";
export var InfoBar = function () {
    var count = React.useContext(BonsCoupsContext).count;
    var t = useTranslation(['news']).t;
    return (_jsx("div", { className: "under-filter-info", children: _jsxs("div", { children: [" ", count, " ", t("éléments")] }) }));
};
